import { MedicalAttestationSending } from '../../lib/types/models/medical-attestation-sending/medical-attestation-sending'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMedicalStatement(id: number): Promise<MedicalAttestationSending> {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getMedicalAttestation.url, { id }))
    .get<MedicalAttestationSending>()
}
